import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { SmartTeamsAppUserGroup } from './SmartTeamsAppUserGroup.js';

@Entity()
export class SmartTeamsAppUser extends MongoEntity {
  static override _class = 'SmartTeamsAppUser';
  static override _collectionName = 'smartteams_app_users';

  /** Links to AdornisUser._id */
  @validate(nonOptional())
  @Field(() => String)
  userId: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  userGroup: Maybe<SmartTeamsAppUserGroup>;

  @Field(() => String)
  primaryLanguage: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  archived: Maybe<boolean>;

  /** Links to ServiceNow FE record (sys_id) — only for FE users */
  @Field(() => String)
  serviceNowFEId: Maybe<string>;

  /**
   * SmartTeamsCustomer._id values this app user represents — only for Customer users.
   * Resolved server-side to ServiceNow client sys_ids when scoping ticket visibility.
   */
  @Field(() => [String], { default: v => v ?? [] })
  customerIds: Maybe<string[]>;

  /** Company association */
  @Field(() => String)
  companyId: Maybe<string>;

  @Field(() => String)
  username: Maybe<string>;

  @Field(() => String)
  email: Maybe<string>;

  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;

  @Field(() => Date, { default: v => v ?? new Date() })
  updatedAt: Maybe<Date>;
}
